import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
  startAfter,
  endBefore,
} from "firebase/firestore";
import { runtimeDb as db } from "../../firestoreStudio/runtime/runtimeDb";

const OP_MAP = {
  "==": (field, value) => where(field, "==", value),
  "!=": (field, value) => where(field, "!=", value),
  "<": (field, value) => where(field, "<", value),
  "<=": (field, value) => where(field, "<=", value),
  ">": (field, value) => where(field, ">", value),
  ">=": (field, value) => where(field, ">=", value),
  arrayContains: (field, value) => where(field, "array-contains", value),
  arrayContainsAny: (field, value) =>
    where(field, "array-contains-any", String(value).split(",").map((s) => s.trim())),
  in: (field, value) => where(field, "in", String(value).split(",").map((s) => s.trim()).slice(0, 10)),
  notIn: (field, value) => where(field, "not-in", String(value).split(",").map((s) => s.trim()).slice(0, 10)),
};

export function buildQuery(collectionName, clauses, sortField, sortDir, pageLimit, cursor, endCursor) {
  const constraints = [];
  for (const c of clauses) {
    if (!c.field || !c.op) continue;
    const fn = OP_MAP[c.op];
    if (fn) constraints.push(fn(c.field, c.value));
  }
  if (sortField) constraints.push(orderBy(sortField, sortDir === "asc" ? "asc" : "desc"));
  constraints.push(limit(Number(pageLimit) || 50));
  let q = query(collection(db, collectionName), ...constraints);
  if (cursor) q = query(q, startAfter(cursor));
  if (endCursor) q = query(q, endBefore(endCursor));
  return q;
}

export async function runQuery(collectionName, clauses, sortField, sortDir, pageLimit) {
  const q = buildQuery(collectionName, clauses, sortField, sortDir, pageLimit);
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, data: d.data() }));
}
